export function convertTiers(tiers) {
  return tiers.map((tier) => ({
    id: tier.TierID, // Renamed property
    tierName: tier.TierName, // Renamed property
    tierColor: tier.TierColor, // Renamed property
  }));
}
export function convertTiersBack(tiers) {
  return tiers.map((tier) => ({
    TierID: tier.id, // Renamed property
    TierName: tier.tierName, // Renamed property
    TierColor: tier.tierColor, // Renamed property
  }));
}

export function convertHolds(holds) {
  return holds.map((hold) => ({
    id: hold.HoldID, // Renamed property
    holdName: hold.HoldName, // Renamed property
    holdColor: hold.HoldColor, // Renamed property
    accessCode: hold.accessCode,
  }));
}

export function convertHoldsBack(holds) {
  return holds.map((hold) => ({
    HoldID: hold.id, // Renamed property
    HoldName: hold.holdName, // Renamed property
    HoldColor: hold.holdColor, // Renamed property
    accessCode: hold.accessCode,
  }));
}
